import React, { useRef, useState } from 'react';
import Image from 'next/image';
// import { ProfileImage, VerifiedIcon } from "@/src/Asset";
import ProfileImage from '@/assets/icons/common/profile.svg';
import sanitizeHTML from '@/utils/sanatizeHtml';

// import styles from '@/styles/ckeditor.module.css';

const ArticleComponent = ({ articleData }: any) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentRef: any = useRef<HTMLDivElement>(null);
  const pageData = articleData?.page_data;

  const handleToggle = () => {
    setIsExpanded((prev) => {
      if (prev) {
        const offset = contentRef.current.getBoundingClientRect().top + window.scrollY - 140;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      }
      return !prev;
    });
  };

  const combinedContent = pageData
    ?.map((data: any) => {
      const heading = data?.heading ?? data?.Heading ?? '';
      const content = sanitizeHTML(data?.content ?? data?.Content ?? '');
      return `<p lang='en' style="font-size: 18px !important; hyphens: auto !important; font-weight: bold; color: #334988; line-height: 1.2 !important; margin: 0 !important;">${heading}</p>${content}`;
    })
    ?.join(' ');

  return (
    <>
      {combinedContent?.length > 0 && (
        <section className="mx-auto my-5 w-[95%] md:w-[90%] lg:max-w-screen-2xl" ref={contentRef}>
          <div className={`relative mb-2 flex w-full rounded bg-white px-4 ${!isExpanded && 'border'}`}>
            <div className="flex w-full flex-col">
              {/* Updated User Section */}
              <div className="my-2  flex gap-x-2">
                <Image
                  src={articleData?.updated_by_user?.profile_picture?.url ?? ProfileImage}
                  alt={articleData?.updated_by_user?.name ?? 'Default_Name'}
                  width={32}
                  height={32}
                  className="size-6 rounded-full object-cover lg:size-8"
                />
                <div className="flex  flex-col">
                  <p className="flex items-center gap-1 font-inter text-sm font-semibold text-amber-900 lg:text-base">
                    {articleData?.updated_by_user?.name ?? 'Tanya Verma'}
                    {/* <span>
                      {" "}
                      <VerifiedIcon />
                    </span> */}
                  </p>
                  <p className="text-xs text-gray-500">
                    {articleData?.updated_by_user?.designation ?? 'Content Writer'}
                  </p>
                  <p className="text-[10px] text-gray-500 sm:text-xs">
                    {articleData?.updated_by_user?.author_bio ?? 'author'}
                  </p>
                </div>
              </div>

              {/* Article Content */}
              <div
                lang="en"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(combinedContent),
                }}
                className={`ckeditorData w-full !overflow-x-auto text-wrap font-inter text-sm md:text-base ${
                  isExpanded ? 'max-h-none' : 'max-h-28 overflow-hidden'
                }`}
              ></div>

              {!isExpanded && (
                <div className="pointer-events-none absolute bottom-8 left-0 h-16 w-full bg-gradient-to-t from-white/90 via-white/75 to-transparent"></div>
              )}

              {/* Toggle Button */}
              <button onClick={handleToggle} className="relative z-10 my-2 bg-gray-50">
                <span className="my-1 rounded bg-primary px-4 py-1 text-sm font-medium text-white">
                  {isExpanded ? 'Read Less' : 'Read More'}
                </span>
              </button>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default ArticleComponent;
